<template>
  <section>

    <v-container fluid v-if="session">
      <v-card>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Start</th>
              <th class="text-left">End</th>
              <th class="text-left">Deadline</th>
              <th class="text-left">Return marked</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ $moment(session.start).format('DD MMMM YYYY hh:mm') }}</td>
              <td>{{ $moment(session.end).format('DD MMMM YYYY hh:mm') }}</td>
              <td>{{ $moment(session.deadline).format('DD MMMM YYYY hh:mm') }}</td>
              <td>{{ $moment(session.return_marked).format('DD MMMM YYYY hh:mm') }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <v-row>
        <v-col>
          <v-card>
            <v-toolbar flat dense>User</v-toolbar>
            <v-divider/>
            <v-list dense>
              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Name</v-list-item-subtitle>
                  <v-list-item-title>{{ session.user.full_name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                  <v-list-item-title v-if="session.user.nickname">{{ session.user.nickname }}</v-list-item-title>
                  <v-list-item-subtitle v-else>* Empty *</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Email</v-list-item-subtitle>
                  <v-list-item-title>{{ session.user.email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-star</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Rating</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ session.user.rating }}</v-list-item-subtitle>
                </v-list-item-content>
<!--                <v-list-item-action>-->
<!--                  <v-rating dense disabled :value="session.user.rating"/>-->
<!--                </v-list-item-action>-->
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col>
          <v-card>
            <v-toolbar flat dense>Tutor</v-toolbar>
            <v-divider/>
            <v-list dense v-if="session.tutor">
              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Name</v-list-item-subtitle>
                  <v-list-item-subtitle>* hidden *</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>PublicID</v-list-item-subtitle>
                  <v-list-item-title>{{ session.tutor.nickname }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Email</v-list-item-subtitle>
                  <v-list-item-subtitle>* hidden *</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-access</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Position</v-list-item-subtitle>
                  <v-list-item-title>{{ session.tutor.profile_type }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

<!--    <v-container fluid v-if="session">-->
<!--      <v-card>-->
<!--        <v-card-title>mock</v-card-title>-->
<!--        <pre>{{session.mock }}</pre>-->
<!--      </v-card>-->
<!--    </v-container>-->
    <template v-if="authUserCourseLeader || authUserAdmin">
      <v-container fluid v-if="session">
        <v-card>
          <v-list-item>
            <v-list-item-content>
            <v-list-item-title>
              Alarm missed deadline
            </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small color="primary" @click="sendMissedDeadlineEmail">Send alarm email</v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-container>
    </template>

    <template v-if="session">
      <v-container fluid v-if="session.mock && session.mock.materials">
        <materials-viewer :items="session.mock.materials"></materials-viewer>

<!--        <v-card class="mt-3">-->
<!--          <v-list-item>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title>-->
<!--                Force open access to materials for candidate-->
<!--              </v-list-item-title>-->
<!--            </v-list-item-content>-->
<!--            <v-list-item-action>-->
<!--              <v-btn small color="primary" @click="openMaterialsAccess">Open access</v-btn>-->
<!--            </v-list-item-action>-->
<!--          </v-list-item>-->
<!--        </v-card>-->
      </v-container>
    </template>

    <v-container fluid v-if="session">
      <v-card>
        <v-toolbar color="blur" flat dense>Review (internal use)</v-toolbar>
        <v-divider/>
        <v-sheet class="overflow-y-auto" max-height="400px">
          <v-card-text class="ql-editor" v-html="session.internal_review"/>
        </v-sheet>
      </v-card>
    </v-container>

    <v-container fluid v-if="session">
      <v-card>
        <v-toolbar color="blur" flat dense>Tutor review (for candidate)</v-toolbar>
        <v-divider/>
        <v-sheet class="overflow-y-auto" max-height="400px">
          <v-card-text class="ql-editor" v-html="session.review"/>
        </v-sheet>
      </v-card>
    </v-container>

    <v-container fluid v-if="session">
      <v-card>
        <v-toolbar color="blur" flat dense>Tasks</v-toolbar>
        <v-divider/>
        <v-sheet class="overflow-y-auto" max-height="400px">
          <v-data-table :headers="mark_sheet_headers"
                        :items="session.tasks"
                        sort-by="position"
                        hide-default-footer
                        disable-pagination
                        dense
          >
            <template v-slot:item.mark="{item}">
              <v-switch class="my-auto" v-model="item.mark" false-value="0" true-value="1" hide-details/>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-container>

    <v-container fluid v-if="session">
      <v-card>
        <v-toolbar color="blur" flat dense>Marks</v-toolbar>
        <v-divider/>
        <v-data-iterator :items="session.marks"
                         disable-pagination
                         disable-filtering
                         hide-default-footer
        >
          <template v-slot:default="props">
            <v-row>
              <v-col cols="12" md="6" class="p-0" v-for="(category, idx) in props.items" :key="idx">
                <v-card flat>
                  <v-card-title> {{ category.name }} {{ category.value }}</v-card-title>
                  <v-divider/>
                  <v-list-item v-for="(sub_category, i) in category.children" :key="i">
                    <v-list-item-content v-text="sub_category.name"/>
                    <v-list-item-action v-text="sub_category.value"/>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>

        <v-divider/>
        <v-card-actions>
          Final mark: {{ session.final_mark }}
        </v-card-actions>
      </v-card>
    </v-container>


  </section>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    mark_sheet_headers: [
      { text: 'Fact', value: 'body' },
      { text: 'Answered', value: 'mark' },
      { text: 'Comments', value: 'comment'},
    ],
    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],
  }),
  methods: {
    sendMissedDeadlineEmail() {
      this.app_loading = true
      this.axios.post(`api/sessions/${this.$route.params.session_id}/deadline-mail`)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.$notify('Success', 'success')
          })
          // eslint-disable-next-line no-unused-vars
          .catch(errors => {})
          .then(() => {this.app_loading = false})
    },
    openMaterialsAccess() {
      this.app_loading = true
      this.axios.post(`api/sessions/${this.$route.params.session_id}/materials/access`)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.$notify('Success', 'success')
          })
          // eslint-disable-next-line no-unused-vars
          .catch(errors => {})
          .then(() => {this.app_loading = false})
    },
  }
}
</script>

